"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Form = /** @class */ (function () {
    function Form(fields) {
        this.fields = fields;
    }
    Form.prototype.SetValidity = function (name, isValid) {
        var oldState;
        if (this.onValidityChanged) {
            oldState = this.isValid;
        }
        this.fields[name] = isValid;
        if (this.onValidityChanged) {
            var newstate = this.isValid;
            if (oldState !== newstate)
                this.onValidityChanged(newstate);
        }
    };
    Object.defineProperty(Form.prototype, "isValid", {
        get: function () {
            // eslint-disable-next-line no-restricted-syntax
            for (var fieldname in this.fields) {
                if (!this.fields[fieldname]) {
                    return false;
                }
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return Form;
}());
exports.Form = Form;
//# sourceMappingURL=Form.js.map